import { ref } from "vue";
import { useTheme as useVuetifyTheme } from "vuetify";

/**
 * Tema do novo design system Bindfy.
 * - Sincroniza o tema do Vuetify (bindfyLight/bindfyDark)
 * - Aplica o atributo data-theme no <body> (usado pelos tokens CSS em redesign.scss)
 * - Persiste a escolha em localStorage
 */

const STORAGE_KEY = "bf-theme";

// estado compartilhado entre instancias
const isDark = ref(
  (typeof localStorage !== "undefined" &&
    localStorage.getItem(STORAGE_KEY) === "bindfyDark") ||
    false
);

function applyBodyAttr(dark: boolean) {
  if (typeof document !== "undefined") {
    document.body.setAttribute("data-theme", dark ? "dark" : "light");
  }
}

export function useAppTheme() {
  const vTheme = useVuetifyTheme();

  const setTheme = (dark: boolean) => {
    isDark.value = dark;
    const name = dark ? "bindfyDark" : "bindfyLight";
    vTheme.global.name.value = name;
    applyBodyAttr(dark);
    if (typeof localStorage !== "undefined") {
      localStorage.setItem(STORAGE_KEY, name);
    }
  };

  const toggleTheme = () => setTheme(!isDark.value);

  // garante que o body reflita o estado atual ao montar
  const syncBody = () => applyBodyAttr(isDark.value);

  return { isDark, setTheme, toggleTheme, syncBody };
}
